import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { RouteStore } from 'fluxible-router';
import Fuse from 'fuse.js';
import { sortBy } from 'lodash';
import NavigationStore from '../../../stores/NavigationStore';
import Spinner from '../../Spinner';
import SearchField from './components/SearchField';
import LettersBar from './components/LettersBar';
import Terms from './components/Terms';
import styles from './styles.module.styl';

class GlossaryPage extends Component {
  state = {
    search: '',
    searchActive: false,
    searchTerms: [],
    searchTermLetters: null
  };

  componentDidMount() {
    const { query } = this.props;

    if (query) {
      this.performSearch(query);
    }
  }

  performSearch(search) {
    if (search.length === 0) {
      return this.setState({
        search,
        searchActive: false,
        searchTerms: [],
        searchTermLetters: null
      });
    }

    const searchTerms = new Fuse(this.props.terms, {
      threshold: 0.2,
      location: 0,
      distance: 1000,
      maxPatternLength: 100,
      minMatchCharLength: 1,
      keys: ['id', 'title']
    }).search(search);

    const glossary = { termsByLetter: {} };

    sortBy(searchTerms, 'id').forEach((obj, id) => {
      const letter = obj.title.charAt(0).toUpperCase();
      glossary.termsByLetter[letter] = glossary.termsByLetter[letter] || [];
      glossary.termsByLetter[letter].push({ id, ...obj });
    });

    return this.setState({
      search,
      searchActive: true,
      searchTerms,
      searchTermsByLetters: glossary.termsByLetter,
      searchTermLetters: Object.keys(glossary.termsByLetter)
    });
  }

  render() {
    const { terms, termLetters, termsByLetter } = this.props;
    const { search, searchActive, searchTermLetters, searchTermsByLetters } = this.state;

    return (
      <div className={`${styles.glossaryPage} container`}>
        <h1>Identity Glossary</h1>

        <p>We've put together a glossary of identity terms for newcomers and seasoned developers, alike. Hopefully this helps put any identity terminology confusion to rest.</p>

        <SearchField
          placeholder="Search terms"
          value={search}
          onChange={e => this.performSearch(e.target.value)}
        />

        <LettersBar letters={searchActive ? searchTermLetters : termLetters} />

        {!terms
          ? <Spinner />
          : <Terms
            letters={searchActive ? searchTermLetters : termLetters}
            termsByLetter={searchActive ? searchTermsByLetters : termsByLetter}
          />
        }
      </div>
    );
  }
}

GlossaryPage.propTypes = {
  termLetters: PropTypes.array,
  termsByLetter: PropTypes.object,
  terms: PropTypes.array,
  query: PropTypes.string
};


export default connectToStores(GlossaryPage, [RouteStore, NavigationStore], ({ getStore }) => {
  const { query: { term } = {} } = getStore(RouteStore).getCurrentRoute();
  const glossary = getStore(NavigationStore).getGlossary();

  return {
    termLetters: glossary.termLetters,
    termsByLetter: glossary.termsByLetter,
    terms: glossary.terms,
    query: term
  };
});
